import React, { useMemo, useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, TextField, Grid, Typography, Link,
} from '@material-ui/core'
import { NumericFormat } from 'react-number-format'
import { useTranslation } from 'react-i18next'
import { disponivel } from '../../titulos-lbc.helpers'

const TransferirModal = ({
  titulo, empresas = [], onFechar, onConfirmar,
}) => {
  const { t, i18n } = useTranslation()
  const ehPt = i18n.language === 'pt-BR'
  const disp = disponivel(titulo)
  const [form, setForm] = useState({ empresaDestinatariaNovaId: '', quantidade: '' })

  const destinos = useMemo(
    () => empresas.filter((e) => Number(e.id) !== Number(titulo.empresaDestinatariaId)),
    [empresas, titulo.empresaDestinatariaId],
  )

  const qtd = Number(form.quantidade)
  const invalido = !form.empresaDestinatariaNovaId || !(qtd > 0) || qtd > disp
  const integral = qtd > 0 && qtd === disp

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onFechar}>
      <DialogTitle>{t('operacoesLbc.transferirTitulo')}</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          {titulo.codigo}
        </Typography>
        <Typography variant="subtitle2" style={{ color: '#219754', fontWeight: 600 }}>
          {t('operacoesLbc.disponivel')}: {disp.toLocaleString(ehPt ? 'pt-BR' : 'en-US', { minimumFractionDigits: 2 })} LBC
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 4 }}>
          <Grid item xs={12}>
            <TextField
              select fullWidth size="small" label={t('operacoesLbc.destinatariaNova')}
              data-testid="transferir-destinataria"
              value={form.empresaDestinatariaNovaId}
              onChange={(e) => setForm((f) => ({ ...f, empresaDestinatariaNovaId: e.target.value }))}
            >
              {destinos.map((e) => <MenuItem key={e.id} value={e.id}>{e.nome}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <NumericFormat
              customInput={TextField} fullWidth size="small" label={t('operacoesLbc.quantidade')}
              data-testid="transferir-quantidade"
              value={form.quantidade}
              thousandSeparator={ehPt ? '.' : ','} decimalSeparator={ehPt ? ',' : '.'}
              decimalScale={2} allowNegative={false}
              onValueChange={(vals) => setForm((f) => ({ ...f, quantidade: vals.floatValue ?? '' }))}
            />
            <Link
              component="button" type="button" variant="caption" underline="always"
              onClick={() => setForm((f) => ({ ...f, quantidade: disp }))}
              style={{ marginTop: 4, display: 'inline-block' }}
            >
              {t('operacoesLbc.transferirTotal')}
            </Link>
          </Grid>
        </Grid>
        {qtd > 0 && (
          <Typography variant="caption" style={{ display: 'block', marginTop: 10, color: integral ? '#EE7D40' : '#607d8b' }}>
            {integral ? t('operacoesLbc.tipoIntegral') : t('operacoesLbc.tipoParcial')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar}>{t('inputs.cancelar')}</Button>
        <Button
          color="primary" variant="contained" disabled={invalido}
          onClick={() => onConfirmar({
            empresaDestinatariaNovaId: Number(form.empresaDestinatariaNovaId),
            quantidade: Number(form.quantidade),
          })}
        >
          {t('operacoesLbc.confirmarTransferencia')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TransferirModal
